import React, { FC } from 'react';
import { observer } from 'mobx-react-lite';
import { useStore } from 'hooks';
import {
  getFormattedConstants,
  getFormattedSelectedConstants,
  onCloseScroll,
} from 'utils';
import { FiasTypes } from '../../constants';
import { FiasSearchProps } from '../../types';
import {
  ChevronIcon,
  CustomTypeStyles,
  TypeSelect,
  Wrapper,
  FixedType,
} from './type-changer.styled';

type TypeChangerProps = {
  menuOpen: boolean;
  setMenuOpen: React.Dispatch<React.SetStateAction<boolean>>;
  withoutHouseGroups?: boolean;
} & Pick<FiasSearchProps, 'isDisabled'>;

export const TypeChanger: FC<TypeChangerProps> = observer(
  ({ menuOpen, setMenuOpen, isDisabled, withoutHouseGroups }) => {
    const { fias } = useStore();

    const handleChangeType = (value: any) => {
      if (value.value === fias.currentFiasSearchType) {
        return;
      }

      if (value.value === 'groups') {
        fias.setShowSecondOptionsField(false);
      }
      fias.setCurrentValueSearch('');
      fias.setLastSelectedHouse({});
      fias.setCurrentFiasSearchType(value.value);
    };

    if (withoutHouseGroups && fias.currentFiasSearchType !== 'houses') {
      fias.setCurrentFiasSearchType('houses');
      fias.setShowSecondOptionsField(false);
      fias.setCurrentValueSearch('');
      fias.setLastSelectedHouse({});
    }

    // если нужен фиксированный вариант "Дома"
    if (withoutHouseGroups) {
      return (
        <Wrapper className="search-control">
          <FixedType>Дома</FixedType>
          {/*<ChevronIcon isOpen={false} />*/}
        </Wrapper>
      );
    }

    // обычный режим с селектом
    const options = getFormattedConstants(FiasTypes);

    return (
      <TypeSelect
        menuIsOpen={menuOpen}
        key={null}
        styles={CustomTypeStyles}
        isMulti={false}
        isSearchable={false}
        isClearable={false}
        classNamePrefix={'fias_type__select'}
        name={'type'}
        options={options}
        value={getFormattedSelectedConstants(
          [fias.currentFiasSearchType],
          FiasTypes
        )}
        onChange={(newValue) => {
          handleChangeType(newValue);
        }}
        onMenuOpen={() => setMenuOpen(true)}
        onMenuClose={() => setMenuOpen(false)}
        closeMenuOnScroll={(e) => onCloseScroll(e)}
        components={{
          Control: (props) => <Control {...props} menuOpen={menuOpen} />,
        }}
        closeMenuOnSelect={true}
        menuPortalTarget={document.body}
        isDisabled={isDisabled}
      />
    );
  }
);

const Control = observer(({ menuOpen, children, ...props }: any) => {
  const { innerProps, innerRef } = props;

  return (
    <Wrapper ref={innerRef} {...innerProps} className="search-control">
      {children}
      <ChevronIcon isOpen={menuOpen} />
    </Wrapper>
  );
});
